module.exports = __webpack_public_path__ + "media/images/map_nihonbashi_direction1-0e0b70239ef34dd8fdefc132ef5f7340.jpg";